export const compareArrays = (a: number[], b: number[]) => {
  if (!a || !b || a.length !== b.length) return false;
  const array1 = [...a];
  const array2 = [...b];
  array1.sort();
  array2.sort();
  return array1.every((element, index) => element === array2[index]);
};
